import { render, staticRenderFns } from "./bnvtomany.vue?vue&type=template&id=a98e371e&scoped=true&"
import script from "./bnvtomany.vue?vue&type=script&lang=js&"
export * from "./bnvtomany.vue?vue&type=script&lang=js&"
import style0 from "./bnvtomany.vue?vue&type=style&index=0&id=a98e371e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e371e",
  null
  
)

export default component.exports